import React from 'react';
import {Button,Modal,ModalBody,ModalFooter,ModalHeader,Spinner} from 'reactstrap';

// Asked when an answer comes from a maker that has already answered this batch.
// The member runs each maker once and DeepSeek last, and DeepSeek is the model
// that names itself wrong -- "GPT-5.1", a Claude, a Gemini -- so a second
// answer from one maker is most likely DeepSeek. The server has saved nothing
// yet; see domain/identity.js. Kept in this module: modules share no code.
export default function IdentityQuestion({question,busy,onAnswer}){
 const close=()=>onAnswer(null);
 return <Modal isOpen={!!question} toggle={close} centered>
  <ModalHeader toggle={close}>Is this DeepSeek?</ModalHeader>
  <ModalBody className="fs-14">
   <p>This answer says it is <strong>{question?.claimed}</strong>, but <strong>{question?.alreadyRecorded}</strong>, also from {question?.maker}, has already answered this batch.</p>
   <p>DeepSeek often gives another model's name. If this is the DeepSeek answer, it will be filed as <strong>{question?.suggest?.name}</strong>, the name of your last DeepSeek answer.</p>
   <p className="text-muted mb-0">Nothing has been saved yet.</p>
  </ModalBody>
  <ModalFooter>
   <Button color="light" disabled={busy} onClick={()=>onAnswer('as-is')}>No, save as {question?.filedAs}</Button>
   <Button color="primary" disabled={busy} onClick={()=>onAnswer('deepseek')}>{busy&&<Spinner size="sm" className="me-1"/>}Yes, save as {question?.suggest?.name}</Button>
  </ModalFooter>
 </Modal>;
}
